export default __webpack_public_path__ + "static/media/ro.9f97fb86.svg";